"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorPause = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    textarea: {
        backgroundColor: 'rgba(131, 144, 157, 0.05)',
    },
    number: {
        width: 80,
        height: 40,
    },
    horizontalRoot: {
        alignItems: 'center',
        alignSelf: 'center',
    },
});
exports.QuestionEditorPause = react_1.default.memo((props) => {
    const { config, onChange } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleChange = (0, useCallforward_1.default)(propertyName => value => {
        config[propertyName] = value;
        onChange(config);
    }, [config, onChange]);
    return (react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true },
        react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', gutter: true, centered: true, classes: { root: myCss.horizontalRoot } },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('pause-for')),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { className: myCss.number, value: config.countDown.toString(), type: "number", onBlur: handleChange('countDown') }),
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('minutes'))),
        react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('instructions')),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { className: myCss.textarea, multiline: true, rows: 2, value: config.instructions, onBlur: handleChange('instructions') })),
        react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('timer-complete-message')),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { className: myCss.textarea, value: config.timerCompleteMessage, onBlur: handleChange('timerCompleteMessage') })),
        react_1.default.createElement(Checkbox_1.default, { checked: config.canSetCountDown, color: lib_palette_1.default.secondary, onChange: handleChange('canSetCountDown'), label: lib_i18n_1.default.t('can-set-countdown-message') })));
});
exports.default = exports.QuestionEditorPause;
